import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import {
  TicketTypeEventIdInputSchema,
  TicketTypeIdInputSchema,
  TicketTypePathParamsValidationSchema,
} from './params';

export const ArchiveTicketTypeParamsValidationSchema = TicketTypePathParamsValidationSchema;

export const ArchiveTicketTypeInputValidationSchema = z.object({
  pageId: TicketTypeEventIdInputSchema,
  ticketGroupId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the ticket group the ticket type is in, from `ticketGroups[].id` in get_event.',
  }),
  ticketTypeId: TicketTypeIdInputSchema,
});

export type ArchiveTicketTypeInput = z.infer<typeof ArchiveTicketTypeInputValidationSchema>;
